export default __webpack_public_path__ + "static/media/CNo.33-9.4ab8f877.jpg";